// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AFK0JSVZpbC4t0X074Xf{margin-top:var(--spacing-xSmall)}.ZtsXg50GrEhKzgpq7xqo{padding:var(--spacing-xSmall)}`, "",{"version":3,"sources":["webpack://./src/App/views/LinkedResponsible/EmptyStateResponsible/EmptyStateResponsible.module.scss"],"names":[],"mappings":"AAAA,sBAAmB,gCAAgC,CAAC,sBAAkB,6BAA6B","sourcesContent":[".table-responsible{margin-top:var(--spacing-xSmall)}.empty-state-card{padding:var(--spacing-xSmall)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-responsible": `AFK0JSVZpbC4t0X074Xf`,
	"empty-state-card": `ZtsXg50GrEhKzgpq7xqo`
};
export default ___CSS_LOADER_EXPORT___;
